// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._1L2wa9osXy_VHO {\n  width: 100%;\n  justify-content: left;\n}\n._1L2wa9osXy_VHO > span {\n  margin-left: -4px;\n}\n._1L2wa9osXy_VHO ._2fqFixbnBCjl76 {\n  margin: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": "_1L2wa9osXy_VHO",
	"buttonLabel": "_2fqFixbnBCjl76"
};
export default ___CSS_LOADER_EXPORT___;
